module.exports = __webpack_public_path__ + "img/TALHADEIRA CÔNICA PONTA PLANA   - DESK.0cf09fa1.png";